(function () {
  var header = document.querySelector('[data-lv-header]');
  if (!header) return;

  var CLOSE_DELAY = 200;
  var closeTimer = null;
  var activeTrigger = null;

  function panelFor(name) {
    return header.querySelector('[data-lv-mega-panel="' + CSS.escape(name) + '"]');
  }

  function openMega(name) {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (activeTrigger === name) return;
    closeMegaImmediate();
    var panel = panelFor(name);
    var trigger = header.querySelector('[data-lv-mega-trigger="' + CSS.escape(name) + '"]');
    var toggle = header.querySelector('[data-lv-mega-toggle="' + CSS.escape(name) + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    if (trigger) trigger.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    activeTrigger = name;
  }

  function closeMegaImmediate() {
    header.querySelectorAll('.lv-mega.is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
    });
    header.querySelectorAll('[data-lv-mega-trigger].is-open').forEach(function (trigger) {
      trigger.classList.remove('is-open');
    });
    header.querySelectorAll('[data-lv-mega-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    activeTrigger = null;
  }

  function scheduleClose() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMegaImmediate, CLOSE_DELAY);
  }

  header.querySelectorAll('[data-lv-mega-trigger]').forEach(function (trigger) {
    var name = trigger.getAttribute('data-lv-mega-trigger');
    trigger.addEventListener('mouseenter', function () {
      openMega(name);
    });
    trigger.addEventListener('mouseleave', scheduleClose);

    var toggle = trigger.querySelector('[data-lv-mega-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (activeTrigger === name) {
          closeMegaImmediate();
        } else {
          openMega(name);
        }
      });
      toggle.addEventListener('focus', function () {
        openMega(name);
      });
    }
  });

  header.querySelectorAll('.lv-mega').forEach(function (panel) {
    panel.addEventListener('mouseenter', function () {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    });
    panel.addEventListener('mouseleave', scheduleClose);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeTrigger) {
      closeMegaImmediate();
    }
  });

  document.addEventListener('click', function (event) {
    if (activeTrigger && !header.contains(event.target)) {
      closeMegaImmediate();
    }
  });

  // ---- Mobile drawer ----
  var drawer = document.getElementById('LovableHeaderDrawer');
  var openBtn = document.querySelector('[data-lv-drawer-open]');
  var closeBtn = drawer ? drawer.querySelector('[data-lv-drawer-close]') : null;

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    if (openBtn) {
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && !drawer.hidden) {
      closeDrawer();
    }
  });

  if (drawer) {
    drawer.querySelectorAll('[data-lv-drawer-toggle]').forEach(function (toggle) {
      var panel = toggle.parentElement.querySelector('[data-lv-drawer-panel]');
      if (!panel) return;
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        panel.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
      });
    });
  }
})();
